export const getters = {

  config: (state) => state.app.config,

  palette: state => state.app.config.palette,

  isLoading: state => state.app.isLoading,

  sidebarMinimized: (state) => state.app.sidebar.minimized,

  businessPlans: state => state.businessPlans,

  authToken: state => state.authToken,

  inProductionEnvironment: () => process.env.VUE_APP_ENVIRONMENT === 'prod' || process.env.VUE_APP_ENVIRONMENT === 'production',

  inStagingEnvironment: () => process.env.VUE_APP_ENVIRONMENT === 'stg' || process.env.VUE_APP_ENVIRONMENT === 'staging',

  authClinicalServices: (state) => {
    return state.services.filter(service => state.authClinicalServiceIds.includes(service.id))
  },

  localizations: () => ['pt', 'en', 'es'],

  sidebarItems: state => {
    if (!state.hasLoaded) {
      return []
    }
    let metaServices = []
    let metaServicesEnd = []
    let depedentComponents = []
    let i = 0
    state.services.forEach(service => {
      if (Array.isArray(service.components)) {
        let metaComponents = service.components.filter(c => c.meta)
        metaComponents.forEach(component => {
          let selectedService = state.services.find(s => s.service === component.meta)
          if (!selectedService) {
            let metaService = metaServices.find(s => s.meta === component.meta)
            if (metaService) {
              metaService.components.push({...component, service})
            } else {
              metaServices.push({
                // id: state.services.length - 1 + i,
                id: 0 - i,
                meta: component.meta,
                service: component.meta,
                icon: 'i-menu-stats-dark',
                slug: component.meta,
                isMetaService: true,
                components: [{...component, service}]
              })
              i++
            }
          } else {
            depedentComponents.push({...component, service})
          }
        })
      }
    })
    let index = metaServices.findIndex(item => item.meta === 'Evollu')
    if (index > -1) {
      metaServices[index].icon = 'i-menu-evollu-dark'
      metaServicesEnd.push(metaServices[index])
      metaServices.splice(index, 1)
    }

    let servicesWithoutMetaComponents = state.services
      .filter(service => service.components && Array.isArray(service.components))
      .map(service => {
        return {
          ...service, isMetaService: false, components: service.components.filter(c => {
            return !c.meta
          }).map(c => {
            return {
              ...c, service,
            }
          }),
        }
      })

    depedentComponents.forEach(component => {
      let selectedService = servicesWithoutMetaComponents.find(s => s.service === component.meta)
      if (selectedService) {
        selectedService.components.push(component)
      }
    })
    let sidebar = metaServices.concat(servicesWithoutMetaComponents)
    return sidebar.concat(metaServicesEnd)
  },

  availableAudProviders: state => {
    let authService = state.services.find(service => service.url === process.env.VUE_APP_AUTH_URL)
    if (authService) {
      return authService.entities.filter(entity => entity.activity_id === 1)
    }
    return []
  },

  availableScreeningProviders: state => {
    let authService = state.services.find(service => service.url === process.env.VUE_APP_AUTH_URL)
    if (authService) {
      return authService.entities.filter(entity => entity.screeningProvider)
    }
    return []
  },

  globalAuthService: state => {
    let globalAuth = {
      entities: [], user_roles: [], user_permissions: [], roles: []
    }

    if (state.services && state.hasLoaded) {
      let authService = state.services.find(service => service.url === process.env.VUE_APP_AUTH_URL)
      if (authService) {
        globalAuth = Object.assign(globalAuth, JSON.parse(JSON.stringify(authService)))

        for (let service of state.services) {
          globalAuth.user_permissions = globalAuth.user_permissions.concat(service.user_permissions.map(up => ({
            ...up, service_id: service.id
          })))
          globalAuth.user_roles = globalAuth.user_roles.concat(service.user_roles)
          globalAuth.roles = globalAuth.roles.concat(service.roles)
          globalAuth.entities = globalAuth.entities.concat(service.entities)
        }

        globalAuth.entities = globalAuth.entities.filter((item, index, self) => index === self.findIndex((t) => (t.id === item.id)))

        globalAuth.user_roles = globalAuth.user_roles.filter((item, index, self) => index === self.findIndex((t) => (t.entity_id === item.entity_id && t.role_id === item.role_id)))

        globalAuth.roles = globalAuth.roles.filter((item, index, self) => index === self.findIndex((t) => (t.id === item.id)))
      }
    }
    return globalAuth
  },

  services: state => state.services,

  clusters: state => state.clusters,

  oneCareToken: state => state.oneCareToken,

  oneCareBaseUrl: state => state.oneCareBaseUrl,

  shouldShowPasswordRenewalWarning: state => state.shouldShowPasswordRenewalWarning

}
